import React from 'react'
import gql from 'graphql-tag'
import Query from 'react-apollo/Query'

export const organizationQuery = gql`
  query applicationsSettingsOrganization($organizationUuid: String!) {
    organization(organizationUuid: $organizationUuid) {
      id
      assessLicenseBreakdown {
        used
        unused
      }
    }
  }
`

interface OrganizationData {
  organization: {
    id: string
    assessLicenseBreakdown: {
      used: number
      unused: number
    }
  }
}

interface Data {
  organizationUuid: string
  numberOfLicensesUsed: number
  numberOfLicensesAvailable: number
}

interface Vars {
  organizationUuid: string
}

export function OrganizationQuery({
  children,
  organizationUuid
}: {
  children: (props: { currentOrganization: Data }) => React.ReactNode
  organizationUuid: string
}) {
  return (
    <Query<OrganizationData, Vars>
      query={organizationQuery}
      variables={{ organizationUuid }}
      fetchPolicy="network-only"
    >
      {({
        data: organizationData,
        error: organizationError,
        loading: organizationLoading
      }) => {
        if (organizationLoading || organizationError || !organizationData) {
          return <div />
        }

        const {
          organization: {
            id: organizationUuid,
            assessLicenseBreakdown: {
              used: numberOfLicensesUsed,
              unused: numberOfLicensesAvailable
            }
          }
        } = organizationData

        const currentOrganization = {
          organizationUuid,
          numberOfLicensesUsed,
          numberOfLicensesAvailable
        }

        return children({
          currentOrganization
        })
      }}
    </Query>
  )
}
